<body>
    <div class=container>
        <img src="assets/front page logo.png" class="heading" alt="Hope Happenings" width="572" height="258" />
        <firebase-ui></firebase-ui>
    </div>
</body>